import { BaseResource } from '../core/base-resource';

export class CustomerInfo extends BaseResource {
  name: string;
  email: string;
  subscribed: boolean;
}
